import { Box } from "@mui/material"
import { registerTab, Tabs } from "lib/@components/tabs"
import { IntroductionGroupSchedules } from "./introduction-group-schedules"
import { IntroductionGroupEditor } from "./introduction-group-editor"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { If } from "lib/@components/switch"
import { Else } from "lib/@components/else"
import { AddIntroSchedulesButton } from "../../plugins/add-intro-schedules-button"
import { References } from "../references"
import { ExtendedNoResults } from "../extended-no-results"
import { Secure } from "lib/authorization/secure"
import { Frag } from "lib/@components/slot/frag"
import { useDemand } from "lib/authorization/use-demand"
import { AUTHORING_EDIT_SCHEDULES_DEMAND } from "authoring/lib/constants/authoring-permissions.mjs"

export function IntroductionGroup() {
    const { hasAddedSchedules } = useBoundContext()
    const canEditSchedule = useDemand(AUTHORING_EDIT_SCHEDULES_DEMAND)
    registerTab({
        tab: "introgroup",
        id: "schedules",
        title: <Box>Schedules</Box>,
        content: <IntroductionGroupSchedules />,
    })
    registerTab({
        tab: "introgroup",
        id: "introduction",
        title: <Box>Introduction</Box>,
        content: <IntroductionGroupEditor />,
        tabProps: { disabled: !canEditSchedule },
    })
    registerTab({
        tab: "introgroup",
        id: "references",
        title: <Box>References</Box>,
        content: <References />,
    })
    return (
        <If truthy={!!hasAddedSchedules}>
            <Tabs id="introgroup" panelHolder={<Box my={2} />} tabHolder={<Box />} />
            <Else>
                <ExtendedNoResults
                    message="You don't have any schedules to add introductions to yet."
                    component={
                        <Secure demand={AUTHORING_EDIT_SCHEDULES_DEMAND} fallback={<Frag />}>
                            <AddIntroSchedulesButton variant="contained" />
                        </Secure>
                    }
                />
            </Else>
        </If>
    )
}
